import Basic from './Basic';

export default Basic;
